module.exports = __webpack_public_path__ + "gn.svg?8e74ea04832ff5ba94ad8330b528d8d1";